import JobList from "./JobList";

export default JobList;
